<template>
  <div class="opple-ability-ui-com-wifi">
    <div class="opple-ability-ui-com-wifi_label">
      <p> {{ $t('addScenes.select') }} WI-FI</p>
      <div
        class="opple-ability-ui-com-tag"
        :class="tag.class"
      >
        {{ tag.text }}
      </div>
    </div>
    <div class="opple-ability-ui-com-wifi_value">
      <div class="opple-ability-ui-com-wifi_value_name">
        <img 
          v-if="Boolean(refreshBtnAction)"
          :src="loadingIcon"
          class="opple-ability-ui-com-wifi_value_name_loading"
          :class="{ active: isRefreshLoading }"
          @click="refreshWifi"
        >
        <div
          v-if="nameRenderType === 1"
          class="opple-ability-ui-com-wifi_value_name_select"
        >
          <el-select
            v-model="nameSelectValue"
            :placeholder="$t('ifttt.iftttPlaceholder')"
            prefix-icon="el-icon-search"
            @change="handlerNameSelectValue"
          >
            <el-option
              v-for="item in wifiOptions"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            />
          </el-select>
        </div>
        <div
          v-else
          class="opple-ability-ui-com-wifi_value_name_input"
        >
          <el-input v-model="nameInputValue" />
        </div>  
        <img 
          :src="penIcon"
          class="opple-ability-ui-com-wifi_value_name_pen"
          @click="triggerNameRenderType"
        >
      </div>
      <div class="opple-ability-ui-com-wifi_value_password">
        <div class="opple-ability-ui-com-wifi_value_password_container">
          <el-input
            :value="passwordValue"
            :type="isPasswordVisible ? 'text': 'password'"
            :placeholder="$t('base.write')"
            @input="onPasswordChange"
          />
          <img
            :src="isPasswordVisible ? passwordVisibleImg : passwordUnVisibleImg"
            class="eye"
            @click="triggerIsPasswordVisible"
          >
        </div>
        <div class="opple-ability-ui-com-wifi_value_password_icon" />
      </div>
    </div>
  </div>
</template>

<script>
import { hexStr2IntArray, GBK2UTF8String } from '@utils/str';
import passwordVisibleImg from '@/assets/img/eye_open_login.png';
import passwordUnVisibleImg from '@/assets/img/eye_close_login.png';
import { FindConfigAbility, CallAction } from '@/axios/IDevice';
import loadingIcon from '@/assets/img/loading.png';
import penIcon from '@/assets/img/pen.png';
import { isWifiConfig, ConfigType } from './utils';
import { jsToUTF8,parseHexString } from '@/utils/utils.js'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    },
    actionList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tag: {},
      nameRenderType: 1, // 1 select 2 input
      nameSelectItem: null,
      passwordSelectItem: null,
      isPasswordVisible: false,
      wifiOptions: [],
      passwordValue: '',
      nameSelectValue: '', // inputValue
      nameInputValue: '', // 输入框value
      passwordVisibleImg,
      passwordUnVisibleImg,
      sessionId: null,
      refreshSessionId: null,
      refreshBtnAction: null,
      isRefreshLoading: false,
      loadingIcon,
      penIcon,
    }
  },

  computed: {
   
  },

  watch: {
    item(newValue) {
      console.log('刷新wifi', newValue);
    },

    actionList(){
      this.initRefreshBtn()
    }
  },

  mounted() {
    console.log('monnn', this.device, this.actionList);
    
    this.initValue(this.item);
    this.initRefreshBtn()
   
  },
   
  methods: {
    handlerNameSelectValue() {
      this.passwordValue = '';
    },

    triggerNameRenderType() {
      const newNameRenderType = this.nameRenderType === 1 ? 2 : 1;

      this.nameRenderType = newNameRenderType;
    },
    getWifiDataFromGpDetail() {

    },

    validate() {
      const { nameSelectItem, passwordSelectItem, passwordValue, nameRenderType } = this;
      const nameValue = nameRenderType === 1? this.nameSelectValue : this.nameInputValue;

      if (!nameValue) {
        return {
          status: false,
          msg: this.$t('sylogs.plhode3')
        };
      }; 

      if (!passwordValue) {
        return {
          status: false,
          msg: this.$t('register.placeholderpsw')
        };
      };

      if (
        nameValue.length < nameSelectItem.Min || 
        nameValue.length > nameSelectItem.Max
      ) {
        return {
          status: false,
          msg: this.$t('deviceMsg.lengthLimit1', {
            Min: nameSelectItem.Min,
            Max: nameSelectItem.Max
          })
        }
      }

      if (
        nameValue.length < passwordSelectItem.Min || 
        nameValue.length > passwordSelectItem.Max
      ) {
        return {
          status: false,
          msg: this.$t('deviceMsg.lengthLimit2', {
            Min: nameSelectItem.Min,
            Max: nameSelectItem.Max
          })
        }
      }

      return {
        status: true,
      }
    },

    getFormData() {
      const { GpDetails, GpNo } = this.item;
      const { nameSelectItem, passwordSelectItem, passwordValue, nameRenderType } = this;

      let ConfigItems = [];

      const nameValue = nameRenderType === 1? this.nameSelectValue : this.nameInputValue;

      ConfigItems.push({
        Key: nameSelectItem.KeyId,
        Values: [ nameValue ]
      });

      ConfigItems.push({
        Key: passwordSelectItem.KeyId,
        Values: [ passwordValue ]
      });

      let reqData = {
        VDeviceId: this.device.VDeviceId,
        GpNo: this.item.GpNo,
        ConfigItems
      }
    
      const find_key_22 = GpDetails.find(item => 
          item.UI &&
          item.UI.ConfigType === 3);

      if(find_key_22) {
        const ssid = jsToUTF8(nameValue,'',true);
        const ssid_length = jsToUTF8(ssid.byteLength,1)
        const password = jsToUTF8(passwordValue,'',true);
        const password_length = jsToUTF8(password.byteLength,1)
        const value = ssid_length + ssid.hexString + password_length + password.hexString;

        console.log('getFormData', value);
        ConfigItems = [{
          Key: find_key_22.KeyId,
          Values: [ value ]
        }]
        reqData.ConfigItems = ConfigItems;
      }

      return reqData;
    },

    initRefreshBtn() {
      let refreshBtn = null;

      (this.actionList || []).forEach(item => {
        const itemActionList = item.ActionList || [];

        itemActionList.forEach(action => {
          const actionValue = action.Values || [];

          actionValue.forEach(item => {
            if (
              item.ValueType === "UIControl_RefreshWiFiList" &&
              item.UI &&
              item.UI.AppValueType === 'UIControl_RefreshWiFiList'
            ) {
              refreshBtn = action;
            }
          })
        })
      })

      this.refreshBtnAction = refreshBtn;
    },

    triggerIsPasswordVisible() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    initTag() {
      const { ResultCode } = this.nameSelectItem;

      switch (ResultCode) {
        case 0:
          this.tag = {
            class: 'pedding',
            text: this.$t('deviceMsg.configing')
          }
          break;
        case 1:
          this.tag = {
            class: 'success',
            text: this.$t('deviceMsg.configsuccess')
          }
          break;
        case 2:
          this.tag = {
            class: 'fail',
            text: this.$t('deviceMsg.configfail')
          }
          break;
        default:
          this.tag = {
            class: 'default',
            text: this.$t('deviceMsg.configdefault')
          }
      }
    },

    async refreshWifi() {

      if(!Boolean(this.refreshBtnAction)) return
      if (this.isRefreshLoading) {
        this.$message({
          type: 'warning',
          message: this.$t('deviceMsg.refreshing')
        });

        return;
      }
      

      this.isRefreshLoading = true;
      let sessionId = 0;
      const defaultValues = [];

      // 生成120-254之间的随机数 直到不等于当前sessionId
      do {
        let min = 128;
        let max = 255;
        let randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
        sessionId = randomNum;
      } while (sessionId === this.sessionId);

      this.refreshSessionId = sessionId;

      // let hex = sessionId.toString(16);

      // if (hex.length % 2 > 0) hex = '0' + hex;

      // defaultValue = hex;      
      console.log('refreshBtnAction', this.refreshBtnAction);

      (this.refreshBtnAction.Values || []).forEach(action => {
        let defaultValue = action.DefaultValue;

        if (action.UI && action.UI.AppValueType === "UIControl_RefreshWiFiList") {
          let hex = sessionId.toString(16);
          if (hex.length % 2 > 0) hex = '0' + hex;

          defaultValue = hex;
        }

        defaultValues.push(defaultValue);
      })

      console.log('refreshBtnAction', sessionId, defaultValues);
      
      const req = { 
        vDeviceId: this.device.VDeviceId, 
        msgType: this.refreshBtnAction.MsgType, 
        channelId: this.device.ChildId, 
        values:  defaultValues.join(',')
      }
  
      try {
        const res = await CallAction(req);

        this.loopGetNewWifi(3)
      } catch (e) {

      }

      // if (action && device) {
      //       this.showLoading();
      //       let defaultValues = [];
      //       action.values?.forEach(value => {
      //           let defaultValue = value.defaultValue;
      //           if (value.uitype == UIControlTypeEnum.RefreshWiFiList) {
      //               let hex = sessionId.toString(16);
      //               if (hex.length%2 > 0) {
      //                   hex = '0' + hex;
      //               }
      //               defaultValue = hex;
      //           }
      //           defaultValues.push(defaultValue);
      //       })
      //       CallAction({ vDeviceId: device.vDeviceId, msgType: action.msgType, channelId: device.childId, values:  defaultValues.join(',')}).then(res => {
      //           console.log('执行成功');
      //           self._onRefreshNewWifi(1);
      //       }).catch((error) => {
      //           OPLogger.log('autoCallDetailAction error', error)
      //           self.showError(error);
      //       });
      //   }
    },

    async loopGetNewWifi(leftCount) {
      console.log('loopGetNewWifi剩余',leftCount);
      if (leftCount === 0) {
        console.log('loopGetNewWifi 失败');
        this.isRefreshLoading = false;
        this.$message({
          type: 'warning',
          message: this.$t('deviceMsg.refreshFail')
        });

        return;
      }

      try {
        // this.$emit('refreshWifi');
        const res = await FindConfigAbility({
          vDeviceId: this.device.VDeviceId,
        });

        if (
          res.Result && 
          Array.isArray(res.Result.GpList)
        ) {
          const wifiItem = res.Result.GpList.find(
            item => isWifiConfig(item)
          );

          const isInitSuccess = this.initValue(wifiItem);

          console.log('刷新是否成功:', isInitSuccess);

          if (!isInitSuccess) {
            setTimeout(() => {
              this.loopGetNewWifi(leftCount - 1);
            }, 2000)
          } else {
            this.isRefreshLoading = false;
            this.$message({
              type: 'success',
              message: this.$t('deviceMsg.refreshSuccess')
            });
          }
        }
      } catch (e) {

      }

      
        // setTimeout(() => {
        //     self._onLoad(() => {
        //         if ((self.sessionId || self.sessionId === 0) && self.sessionId == self.refreshSessionId) { //刷新成功
        //             // self.showError('')
        //             if (self.isComplete) {
        //                 self.hideLoading();
        //             }else{ //部分上报成功
        //                 if (tag < count) { //继续查询
        //                     self._onRefreshNewWifi(tag + 1);
        //                 }else{
        //                     self.hideLoading();
        //                 }
        //             }
        //         }else{
        //             if (tag < count) { //继续查询
        //                 self._onRefreshNewWifi(tag + 1);
        //             }else{ //刷新失败
        //                 OPLogger.log('isComplete sessionId refreshSessionId', self.isComplete, self.sessionId, self.refreshSessionId)
        //                 self.showError(I18n.t('device.RefreshFailed'));
        //             }
        //         }
        //         console.log('刷新结果', self.sessionId, self.isComplete, self.refreshSessionId);
        //     });
        // }, timeout);
    },

    onPasswordChange(value) {
      if (/^[^\u4e00-\u9fa5\s\n]*$/.test(value)) {
        this.passwordValue = value;
      }
    },
  
    initValue(wifiItem) {
      const { GpDetails } = wifiItem;

      let wifiOptions = [];
      let key_22 = null;
      // console.log('this.wifiOptions', GpDetails);
      GpDetails.forEach(item => {
        if (
          item.IsShow &&
          item.ParaType === 'String' &&
          item.ValueType === 'Input' &&
          item.UI &&
          item.UI.ConfigType === 1
        ) {
          this.nameSelectItem = item;
        }

        if (
          item.IsShow &&
          item.ParaType === 'String' &&
          item.ValueType === 'Input' &&
          item.UI &&
          item.UI.ConfigType === 2
        ) {
          this.passwordSelectItem = item;
        }

        if(
          item.IsShow &&
          item.UI &&
          item.UI.ConfigType === 3
        ) {
          key_22 = item
        }

        if (
          !item.IsShow &&
          item.ParaType === 'HexString'
        ) {
          wifiOptions.push(item);
        }
      })

      // 有keyid 22的数据
      if(key_22 && key_22.DefaultValue) {
        let {value,next} = parseHexString(key_22.DefaultValue)
        if(value){
          this.nameSelectItem.DefaultValue = value;
        }
        if(next){
          let {value} = parseHexString(next)
          this.passwordSelectItem.DefaultValue = value;
        }
      }
      

      this.initTag();

      const { wifiList, isComplete, sessionId } = this.parseWifiList(wifiOptions);
      

      this.wifiOptions = wifiList.map((name, index) => ({
        value: index,
        label: name
      }));
  
      console.log('wifiList, isComplete, sessionId',this.sessionId, this.refreshSessionId, sessionId, isComplete);

      // 首次进入获取数据 或者
      if (this.sessionId === null || this.refreshSessionId === sessionId) {
        this.sessionId = sessionId;
        if (wifiList.includes(this.nameSelectItem.DefaultValue)) {
          this.nameRenderType = 1;
          this.nameSelectValue = this.nameSelectItem.DefaultValue
        } else if (!!this.nameSelectItem.DefaultValue) {
          this.nameRenderType = 2;
          this.nameInputValue = this.nameSelectItem.DefaultValue
        }

        
        this.passwordValue = this.passwordSelectItem.DefaultValue || '';

        if (!this.passwordValue) {
          this.isPasswordVisible = true;
        }

        // 是否完成
        return isComplete;
      } else {
        return false;
      }
      // console.log('this.wifiOptions', this.wifiOptions);
      
      // console.log('nameSelect', nameSelect, passwordSelect, wifiOptions);
    },

    parseWifiList(wifiOptions) {
      const wifiList = [];
      let isComplete = false;
      let sessionId = null;
      for (let i = 0; i < wifiOptions.length; i++) {
        const item = wifiOptions[i];
        
        const { DefaultValue } = item;
        if (!DefaultValue || !DefaultValue.length) continue;
        
        let sessionStr = parseInt(DefaultValue.slice(0, 2), 16);
        let isFinishStr = parseInt(DefaultValue.slice(2, 4), 16);
        let count = parseInt(DefaultValue.slice(4, 6), 16);
        let firstLenght = parseInt(DefaultValue.slice(6, 8), 16) * 2;
        let loc = 6 + 2;

        if (sessionId === null) {
          sessionId =  sessionStr;
        } else if (sessionStr !== sessionId) {
          console.log('sessionId不对 包数据不正确', sessionStr);
          continue;
        }

        while (DefaultValue.length >= loc + firstLenght) {
          let ssid =  DefaultValue.slice(loc, loc + firstLenght);
          let apCodes = hexStr2IntArray(ssid);  
          let ssidStr = GBK2UTF8String(apCodes);

          wifiList.push(ssidStr);

          loc += firstLenght;
          //是否还有下一个
          if (DefaultValue.length >= loc + 2) {
            firstLenght = parseInt(DefaultValue.slice(loc, loc + 2), 16) * 2;
          }
          loc += 2;
          // console.log('DeviceSettingWiFiScreen loc', DefaultValue)
        }

        if (isFinishStr == 1) {
          isComplete = true;
          break;
        }
      }
      
      
      // console.log('wifiOptions', wifiList, isComplete, sessionId);

      return {
        wifiList,
        isComplete,
        sessionId
      }
    },

    // parseWifiConfigs(settingConfigs, SessionId = 0) {
    //   let wifiList = []
    //   let isComplete = false
    //   let sessionId ;

    //   let confige = settingConfigs.find(item => {
    //       let temp = item.data?.find(configeItem => {
    //         console.log('DeviceSettingWiFiScreen', configeItem);
    //           if (configeItem.inputType == InputType.ConfigWiFiReport) {
    //             const {value} = configeItem; 
    //             if (value && value.length > 8) {
    //               let sessionStr = parseInt(value.slice(0, 2), 16);
    //               let isFinishStr = parseInt(value.slice(2, 4), 16);
    //               let count = parseInt(value.slice(4, 6), 16);
    //               console.log('DeviceSettingWiFiScreen', sessionStr, isFinishStr, count)
    //               let firstLenght = parseInt(value.slice(6, 8), 16) * 2;
    //               let loc = 6 + 2;
    //               //第二包数据
    //               if (sessionId || sessionId == 0) {
    //                 if (sessionId != sessionStr) {
    //                   console.log('sessionId不对 包数据不正确', sessionStr)
    //                   return false;
    //                 }
    //               }else{// 第一包数据
    //                 sessionId = sessionStr;
    //               }
    //               while (value.length >= loc + firstLenght) {
    //                 let ssid =  value.slice(loc, loc + firstLenght);
    //                 let apCodes = hexStr2IntArray(ssid);  
    //                 let ssidStr = GBK2UTF8String(apCodes);
    //                 wifiList.push(ssidStr);
    //                 loc += firstLenght;
    //                 //是否还有下一个
    //                 if (value.length >= loc +2) {
    //                   firstLenght = parseInt(value.slice(loc, loc +2), 16) * 2;
    //                 }
    //                 loc += 2;
    //                 console.log('DeviceSettingWiFiScreen loc', loc, firstLenght)
    //               }
    //               if (isFinishStr == 1) {
    //                 isComplete = true;
    //                 return true
    //               }
    //             }
    //           }
    //           return false;
    //       })
    //       return !!temp
    //   })
    //   return {wifiList, isComplete, sessionId};
    // },

    getData() {
    }
  },
};
</script>

<style lang="scss" scoped>
.opple-ability-ui-com-wifi {
  display: flex;
  justify-content: space-between;
  padding-right: 50px;

  &_label {
    display: flex;
    align-items: center;
  }

  &_value {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &_name {
      display: flex;
      align-items: center;

      &_select {
        width: 180px;
        .el-select {
          width: 100%;
        }
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      img {
        padding-left: 10px;
        padding-right: 10px;
      }

      &_loading.active {
        animation: rotate infinite linear 2s;
      }

      &_pen {
        
        border-left: 1px solid #eee;
      }

      img {

      }

      &_input {
        width: 180px;
      }

      i {
        margin-right: 10px;

        // &.el-icon-edit {
        //   padding-left: 10px;
        //   border-left: 1px solid #eee;
        // }
      }
    }

    &_password {
      display: flex;
      margin-top: 10px;
  
      &_container {
        position: relative;
        width: 180px;
      }

      &_icon {
        width: 37px;
      }

      img {
        position: absolute;
        right: 9px;
        top: 15px;
      } 
    }
  }

  .opple-ability-ui-com-tag {
    font-size: 12px;
    border-radius: 4px;
    padding: 0 4px;
    margin-left: 8px;
    line-height: 20px;

    &.success {
      border: 1px solid #67c23a;
      color: #67c23a;
    }

    &.pedding {
      border: 1px solid #286fe8;
      color: #286fe8;
    }

    &.fail {
      border: 1px solid #e6a23c;
      color: #e6a23c;
    }

    &.default {
      border: 1px solid #67c23a;
      color: #67c23a;
    }
  }
}

</style>